import {
  employeeProfileAiSummarySectionTranslation,
  EmployeeProfileAiSummarySectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/aiSummary/employeeProfile.aiSummary.translation.pl.ts';
import {
  employeeProfileBasicSectionTranslation,
  EmployeeProfileBasicSectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/basic/employeeProfile.basic.translation.pl.ts';
import {
  EmployeeProfileCorporateTrainingsSectionTranslation,
  employeeProfileCorporateTrainingsSectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/corporateTrainings/employeeProfile.corporateTrainings.translation.pl.ts';
import { EmployeeProfileDevelopmentChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentChat/employeeProfile.chat.translation.en.ts';
import { employeeProfileDevelopmentChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentChat/employeeProfile.chat.translation.pl.ts';
import {
  EmployeeProfileDevelopmentPlanSectionTranslation,
  employeeProfileDevelopmentPlanSectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/developmentPlan/employeeProfile.developmentPlan.translation.pl.ts';
import {
  employeeProfileOrganizationalAssignmentSectionTranslation,
  EmployeeProfileOrganizationalAssignmentSectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/organizationalAssignment/employeeProfile.organizationalAssignment.translation.pl.ts';
import {
  employeeProfilePotentialOverviewSectionTranslation,
  EmployeeProfilePotentialOverviewSectionTranslation,
} from '@/assets/locales/views/employeeProfile/sections/potentialOverview/employeeProfile.potentialOverview.translation.pl.ts';

import { EmployeeProfileChatFormSectionTranslation } from './sections/chat/employeeProfile.chat.translation.en';
import { employeeProfileChatFormSectionTranslation } from './sections/chat/employeeProfile.chat.translation.pl';
import {
  employeeProfileGradeSystemSectionTranslation,
  EmployeeProfileGradeSystemSectionTranslation,
} from './sections/gradeSystem/employeeProfile.gradeSystem.translation.pl';

export type EmployeeProfileTranslation = {
  aiSummary: EmployeeProfileAiSummarySectionTranslation;
  basic: EmployeeProfileBasicSectionTranslation;
  chat: EmployeeProfileChatFormSectionTranslation;
  corporateTrainings: EmployeeProfileCorporateTrainingsSectionTranslation;
  developmentChat: EmployeeProfileDevelopmentChatFormSectionTranslation;
  developmentPlan: EmployeeProfileDevelopmentPlanSectionTranslation;
  downloadFlashcard: string;
  generatingFlashcard: string;
  goToDevelopmentChat: string;
  gradeSystem: EmployeeProfileGradeSystemSectionTranslation;
  noAccess: {
    description: string;
    title: string;
  };
  noApplicationAccess: {
    description: string;
    title: string;
  };
  noPermissions: {
    confirmButton: string;
    description: string;
    title: string;
  };
  organizationalAssignment: EmployeeProfileOrganizationalAssignmentSectionTranslation;
  potentialOverview: EmployeeProfilePotentialOverviewSectionTranslation;
  roleSelectionModal: {
    cancelButton: string;
    confirmButton: string;
    content: string;
    title: string;
  };
  util: {
    yearsMonths: string;
  };
  viewingAs: string;
};

export const employeeProfileTranslation: EmployeeProfileTranslation = {
  aiSummary: employeeProfileAiSummarySectionTranslation,
  basic: employeeProfileBasicSectionTranslation,
  chat: employeeProfileChatFormSectionTranslation,
  corporateTrainings: employeeProfileCorporateTrainingsSectionTranslation,
  developmentChat: employeeProfileDevelopmentChatFormSectionTranslation,
  developmentPlan: employeeProfileDevelopmentPlanSectionTranslation,
  downloadFlashcard: 'Pobierz fiszkę',
  generatingFlashcard: 'Trwa generowanie...',
  goToDevelopmentChat: 'Budowanie planu rozwoju',
  gradeSystem: employeeProfileGradeSystemSectionTranslation,
  noAccess: {
    description:
      'Nie masz uprawnień do przeglądania tego profilu. Skontaktuj się z administratorem, jeśli uważasz, że to błąd.',
    title: 'Brak dostępu',
  },
  noApplicationAccess: {
    description:
      'Nie masz uprawnień do aplikacji. Skontaktuj się z administratorem, jeśli uważasz, że to błąd.',
    title: 'Brak dostępu',
  },
  noPermissions: {
    confirmButton: 'Wróć do wyszukiwarki',
    description:
      'Nie masz uprawnień do przeglądania żadnych sekcji tego profilu pracownika. Skontaktuj się z administratorem, jeśli uważasz, że to błąd.',
    title: 'Brak uprawnień',
  },
  organizationalAssignment: employeeProfileOrganizationalAssignmentSectionTranslation,
  potentialOverview: employeeProfilePotentialOverviewSectionTranslation,
  roleSelectionModal: {
    cancelButton: 'Anuluj',
    confirmButton: 'Wybierz',
    content: 'Wybierz rolę, w jakiej chcesz przeglądać profil:',
    title: 'Wybór roli',
  },
  util: {
    yearsMonths: '{{years}} lat, {{months}} miesięcy',
  },
  viewingAs: 'Przeglądasz profil jako:',
};
